import { Card, CardContent, Grid } from '@mui/material'
import React from 'react'
import { useStyles } from './styles'
import { ListElementText } from '../../UI/ListElementText'
import { PickingDiff } from '../../../interfaces/PickingValidate/PickingDiff'

interface PickingDiffTotalsProps {
  element: PickingDiff
}

export const PickingDiffTotals: React.FC<PickingDiffTotalsProps> = ({
  element
}) => {
  const classes = useStyles()
  return (
    <Card className={classes.root}>
      <div className={classes.details}>
        <CardContent className={classes.content}>
          <Grid container direction='row' spacing={2}>
            <Grid item xs={12} sm={2}>
              <ListElementText
                title='TOTAL RUTA'
                text={element.realQty}
                center
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <ListElementText
                title='PICKEADAS'
                text={element.pickedQty}
                center
              />
            </Grid>
            <Grid item xs={12} sm={1}>
              <ListElementText
                center
                title='AJUSTES'
                text={element.signedValueLabel(element.pickedAdjustmentQty)}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <ListElementText
                center
                title='FALTANTES'
                text={element.pendingLabel()}
              />
            </Grid>
            <Grid item xs={12} sm={2} lg={2}>
              <ListElementText
                center
                title='DIFERENCIAS'
                text={element.differenceLabel()}
              />
            </Grid>
            <Grid item xs={12} sm={1}>
              <ListElementText
                center
                title='MERMAS'
                text={element.reductionLabel()}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <ListElementText
                center
                title='RECHAZO COMERCIAL'
                text={element.commercialRejectionLabel()}
              />
            </Grid>
          </Grid>
        </CardContent>
      </div>
    </Card>
  )
}
